import {useResizedImageEnhanced} from "../../../../../../shared/hooks/useResizedImageEnhanced";
import {FC, useMemo} from "react";
import {Card, Endpoints} from "@brg/api";
import styled, {css} from "styled-components";
import {Colors, FlexBox} from "@brg/ui";
import {RingPositions} from "../../../../../../shared/constants/ringPositionType";
import {LayoutConst} from "../../../../../../core";
import { useTranslation } from "react-i18next";
import { isDisallowedForCompositeWorks } from "./isCardBlockedForPaidBook";
import { getRepBaseByProvider } from "shared/helpers/shopCardContentDisplayUrl";

const BookCardContainer = styled.div`
  position: relative;
`;

const CardImgFeed = styled.img`
  width: 100%;
  background: #ffffff;
  cursor: pointer;
  margin-bottom: 24px;
`;

const TopRightContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`

const NotAvailableShadow = styled(FlexBox)`
  position: absolute;
  width: 100%;
  height: calc(100% - 24px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.48);
  cursor: auto;
  
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.geoWhite100};
  padding: 0 30px;
  pointer-events: none;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
  }
`

const SelectRing = styled(FlexBox)<{ active?: boolean, ringPosition?: RingPositions, disable?: boolean }>`
  background: rgba(24, 26, 28, 0.5);
  border: 2px solid #fefefe;
  backdrop-filter: blur(2px);
  box-sizing: border-box;
  border-radius: 34px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: white;

  ${({ disable }) => disable && css`
    pointer-events: none;
  `}

  ${({ ringPosition }) => ringPosition ? css`
    margin: ${ringPosition === RingPositions.left ? '0 auto 0 0' : '0 0 0 auto'};
  ` : null};

  @media(max-width: ${LayoutConst.screen.md}px) {
    z-index: 5;
    width: 24px;
    height: 24px;
  }

  svg {
    outline: none !important;
  }

  ${p => p.active ? css`
    background: rgba(254, 254, 254, 1);
    border: 2px rgba(254, 254, 254, 1);
    box-sizing: border-box;
    border-radius: 34px;
  ` : null}
`;


export const getCardUrl = (card: any) => {
    const isArtz =
      card?.templateType?.context === 'artz' ||
      card?.cardProviderId === 'artz' ||
      card?.typeCard === 'artz';
    const providerId = isArtz ? 'artz' : card?.cardProviderId;
    const baseUrl = getRepBaseByProvider(providerId);

    return `${baseUrl}/card/${card?.cardId}`
}

export const BookCard: FC<{card: Card<"Global">, isActive?: boolean, isSelectable?: boolean, onSelect?: (val: string) => void}> =
    ({card, isActive, isSelectable, onSelect}) => {

    const baseUrl = Endpoints.files;
    const [img, containerRef] = useResizedImageEnhanced(card.images);

    const url = useMemo(() => {
      const isArtz =
        card?.templateType?.context === 'artz' ||
        card?.cardProviderId === 'artz' ||
        card?.typeCard === 'artz';
      const providerId = isArtz ? 'artz' : card?.cardProviderId;
      const baseUrl = getRepBaseByProvider(providerId);

      return `${baseUrl}/card/${card?.cardId}`
    }, [card])

    const isNotPaymentCard = useMemo(
        () => card?.printQuality === "A5" || isDisallowedForCompositeWorks(card),
        [card]
    )
    
    return (
      <> <a href={isSelectable ? undefined : url} target={"blank"}><BookCardContainer ref={containerRef}>
        {(isSelectable && isNotPaymentCard) && <NotAvailableShadow>Недоступно для прикрепления</NotAvailableShadow>}
        {(isSelectable && !isNotPaymentCard) && <TopRightContainer>
                {(isSelectable || isActive) && <SelectRing active={isActive} onClick={(ev: any) => {
                    if (onSelect && isSelectable) {
                        ev.stopPropagation();
                        ev.preventDefault();
                        // @ts-ignore
                        onSelect(card?.itemId ?? '');
                    }
                }}>
                    {isActive && <div>
                        <svg
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                     4.02557L1 4.85653Z"
                                fill="#FEFEFE"
                                stroke="black"
                            />
                        </svg>
                    </div>}
                </SelectRing>}
            </TopRightContainer>}
       <CardImgFeed src={`${baseUrl}/${img?.url || ''}`}/> 
    </BookCardContainer></a>
      </>
    )
}import {useResizedImageEnhanced} from "../../../../../../shared/hooks/useResizedImageEnhanced";
import {FC, useMemo} from "react";
import {Card, Endpoints} from "@brg/api";
import styled, {css} from "styled-components";
import {Colors, FlexBox} from "@brg/ui";
import {RingPositions} from "../../../../../../shared/constants/ringPositionType";
import {LayoutConst} from "../../../../../../core";
import { useTranslation } from "react-i18next";
import { isDisallowedForCompositeWorks } from "./isCardBlockedForPaidBook";
import { getRepBaseByProvider } from "shared/helpers/shopCardContentDisplayUrl";

const BookCardContainer = styled.div`
  position: relative;
`;

const CardImgFeed = styled.img`
  width: 100%;
  background: #ffffff;
  cursor: pointer;
  margin-bottom: 24px;
`;

const TopRightContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`

const NotAvailableShadow = styled(FlexBox)`
  position: absolute;
  width: 100%;
  height: calc(100% - 24px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.48);
  cursor: auto;
  
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.geoWhite100};
  padding: 0 30px;
  pointer-events: none;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
  }
`

const SelectRing = styled(FlexBox)<{ active?: boolean, ringPosition?: RingPositions, disable?: boolean }>`
  background: rgba(24, 26, 28, 0.5);
  border: 2px solid #fefefe;
  backdrop-filter: blur(2px);
  box-sizing: border-box;
  border-radius: 34px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: white;

  ${({ disable }) => disable && css`
    pointer-events: none;
  `}

  ${({ ringPosition }) => ringPosition ? css`
    margin: ${ringPosition === RingPositions.left ? '0 auto 0 0' : '0 0 0 auto'};
  ` : null};

  @media(max-width: ${LayoutConst.screen.md}px) {
    z-index: 5;
    width: 24px;
    height: 24px;
  }

  svg {
    outline: none !important;
  }

  ${p => p.active ? css`
    background: rgba(254, 254, 254, 1);
    border: 2px rgba(254, 254, 254, 1);
    box-sizing: border-box;
    border-radius: 34px;
  ` : null}
`;


export const getCardUrl = (card: any) => {
    const isArtz =
      card?.templateType?.context === 'artz' ||
      card?.cardProviderId === 'artz' ||
      card?.typeCard === 'artz';
    const providerId = isArtz ? 'artz' : card?.cardProviderId;
    const baseUrl = getRepBaseByProvider(providerId);

    return `${baseUrl}/card/${card?.cardId}`
}

export const BookCard: FC<{card: Card<"Global">, isActive?: boolean, isSelectable?: boolean, onSelect?: (val: string) => void}> =
    ({card, isActive, isSelectable, onSelect}) => {

    const baseUrl = Endpoints.files;
    const [img, containerRef] = useResizedImageEnhanced(card.images);

    const url = useMemo(() => {
      const isArtz =
        card?.templateType?.context === 'artz' ||
        card?.cardProviderId === 'artz' ||
        card?.typeCard === 'artz';
      const providerId = isArtz ? 'artz' : card?.cardProviderId;
      const baseUrl = getRepBaseByProvider(providerId);

      return `${baseUrl}/card/${card?.cardId}`
    }, [card])

    const isNotPaymentCard = useMemo(
        () => card?.printQuality === "A5" || isDisallowedForCompositeWorks(card),
        [card]
    )
    
    return (
      <> <a href={isSelectable ? undefined : url} target={"blank"}><BookCardContainer ref={containerRef}>
        {(isSelectable && isNotPaymentCard) && <NotAvailableShadow>Недоступно для прикрепления</NotAvailableShadow>}
        {(isSelectable && !isNotPaymentCard) && <TopRightContainer>
                {(isSelectable || isActive) && <SelectRing active={isActive} onClick={(ev: any) => {
                    if (onSelect && isSelectable) {
                        ev.stopPropagation();
                        ev.preventDefault();
                        // @ts-ignore
                        onSelect(card?.itemId ?? '');
                    }
                }}>
                    {isActive && <div>
                        <svg
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                     4.02557L1 4.85653Z"
                                fill="#FEFEFE"
                                stroke="black"
                            />
                        </svg>
                    </div>}
                </SelectRing>}
            </TopRightContainer>}
       <CardImgFeed src={`${baseUrl}/${img?.url || ''}`}/> 
    </BookCardContainer></a>
      </>
    )
}